import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar } from 'react-data-grid-addons';
import jQuery from 'jquery';

import Core from './../../../Core/Core';
import Header from './../../Header';
import { sortRows, getRows, getCellActions, handleFilterChange, getValidFilterValues } from './../../Proposal/GridManager';
import AllColumns from './../../Proposal/AllColumns';
import MainColumns from './../../Proposal/MainColumns';
import ProposalForm from './../../Proposal/ProposalForm';
import BtnGroup from './../../Proposal/BtnGroup';

import ErrorBoundary from '../ErrorBoundary';
import ErrorManager from './../../../Core/ErrorManager';

class Proposal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      proposals: [],
      proposal: {
        discount: 0
      },
      dealerships: [],
      conseilors: [],
      models: [],
      filters: {},
      isFilterToggled: false,
      allColumnsToggled: false,
      param: '',
      startDate: null,
      endDate: null,
      user_dealerships: '',
      sold: 0,
    };

    this.grid = React.createRef();
    this.load = this.load.bind(this);
    this.getProposal = this.getProposal.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.onGridRowsUpdated = this.onGridRowsUpdated.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.onToggle = this.onToggle.bind(this);

    this.conseilors = [];
    this.submit = this.submit.bind(this);
    this.clearProposal = this.clearProposal.bind(this);
    this.handleRedux = this.handleRedux.bind(this);
    this.loadProposal = this.loadProposal.bind(this);

    this.load();
  }

  componentDidMount() {
    document.title = 'W-F: Liste des propositions';
  }

  componentDidUpdate() {
    //Affiche la barre de filtres après la création de la grille
    if (this.grid.current && !this.state.isFilterToggled) {
      this.grid.current.onToggleFilter();
      this.setState({
        isFilterToggled: true,
      });
    }
  }

  load() {
    //Limite les accès des user à leurs concessions
    let user = JSON.parse(localStorage.getItem('User'));
    if (user && user.email) {
      Core.Instance.Request(Core.Address + 'GetUserFromEmail/?email=' + user.email, null, 'GET').then((json) => {
        if (!json[0]) {
          // L'utilisateur n'a pas été trouvé
          return;
        }
        let user_dealerships = json[0].dealerships;
        if (user_dealerships && user_dealerships[0] === ';') user_dealerships = user_dealerships.substring(1);
        let dealerships = null;
        if (user_dealerships) {
          dealerships = user_dealerships.split(';').map((shortname, index) => {
            return { id: index, name: shortname };
          });
        }
        this.setState(
          {
            user_dealerships: user_dealerships ? user_dealerships : '',
            dealerships: dealerships ? dealerships : [],
          },
          () => {
            //Récupère toutes les offres
            this.getProposal('');
            Core.Instance.Request(Core.Address + 'Conseilor', null, 'GET').then((json) => {
              //Affiche seulement les vendeurs des concessions du User
              let dealerships = this.state.user_dealerships.split(';');
              let conseilors = json.filter(function (item) {
                return dealerships.indexOf(item.shortname) !== -1;
              });
              //Trie les conseillers par nom de concession puis par prénom
              conseilors = conseilors.sort((a, b) => {
                if (a.shortname > b.shortname) return 1;
                if (a.shortname < b.shortname) return -1;

                if (a.name > b.name) return 1;
                if (a.name < b.name) return -1;
              });
              this.setState({
                conseilors: json != null ? conseilors : [],
              });
            });
          },
        );
      });
    }

    Core.Instance.Request(Core.Address + 'Flash/?by=model&order=asc', null, 'GET').then((json) => {
      this.setState({
        models: json != null ? json : [],
      });
    });
  }

  //Récupère les propositions des btn-grp
  getProposal = () => {
    const { param, user_dealerships, sold, startDate, endDate } = this.state;
    if (user_dealerships) {
      let request = Core.Address + 'GetProposal/?param=' + param + '&user_dealerships=' + user_dealerships + '&sold=' + sold;
      if (startDate && endDate) {
        request += '&startDate=' + startDate + '&endDate=' + endDate;
      }

      Core.Instance.Request(request, null, 'GET').then((json) => {
        let proposals = json;
        if (proposals.length > 0) {
          for (let i = 0; i < proposals.length; i++) {
            if (proposals[i].impact_loyalty < 0) {
              proposals[i].impact_loyalty = 0;
            }
            if (proposals[i].impact_conquest < 0) {
              proposals[i].impact_conquest = 0;
            }
          }
        }
        this.setState({
          proposals: proposals != null ? proposals : [],
        });
      });
    }
  };

  // Filtres
  handleFilterChange = (event) => {
    let name = event.target.name;
    this.setState(
      {
        [name]: event.target.value,
      },
      () => this.getProposal(),
    );
  };

  onToggle() {
    this.setState({ allColumnsToggled: !this.state.allColumnsToggled });
  }

  onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    this.setState(
      (state) => {
        console.log(updated);
        const proposals = state.proposals.slice();
        for (let i = fromRow; i <= toRow; i++) {
          if (updated[Object.keys(updated)[0]] === '') {
            updated[Object.keys(updated)[0]] = null;
          }

          if (updated.conseilor) {
            let value = updated.conseilor.split('|');
            updated.conseilor = value[0];
            updated.type = value[1];
          }
          proposals[i] = { ...proposals[i], ...updated };
        }
        return { proposals };
      },
      () => {
        Core.Instance.Request(Core.Address + 'UpdateProposal/', this.state.proposals[fromRow], 'PUT')
          .then((json) => {
            if (json === null) {
              alert('Le modèle ne correspond à aucun Flash');
            }
          })
          .catch((error) => {
            alert('Une erreur inconnue est survenue.');
          });
        window.location.reload();
      },
    );
  };

  handleCheckbox = (rowIdx: number, columnKey: string, rowData, e: Event) => {
    let proposals = this.state.proposals;
    proposals[rowIdx][columnKey] = proposals[rowIdx][columnKey] ? !proposals[rowIdx][columnKey] : 1;

    if (columnKey === 'sold') {
      let now = new Date().getTime() / 1000;
      proposals[rowIdx]['date_sold'] = now;
    }

    this.setState(
      {
        proposals: proposals,
      },
      () => {
        Core.Instance.Request(Core.Address + 'UpdateProposal/', this.state.proposals[rowIdx], 'PUT')
          .then((json) => {
            if (json === null) {
              alert('Le modèle ne correspond à aucun Flash');
            }
          })
          .catch((error) => {
            alert('Une erreur inconnue est survenue.');
          });
        window.location.reload();
      },
    );
  };

  // Charge la propostion sélectionnée pour édition
  loadProposal(id) {
    if (id) {
      Core.Instance.Request(Core.Address + 'Proposal/' + id, null, 'GET').then((json) => {
        jQuery('#addProposalModal').modal('show');
        this.setState({
          proposal: json != null ? json : {},
        });
      });
    }

    Core.Instance.Request(Core.Address + 'Conseilor', null, 'GET').then((json) => {
      //Affiche seulement les vendeurs des concessions du User
      let dealerships = this.state.user_dealerships.split(';');
      let conseilors = json.filter(function (item) {
        return dealerships.indexOf(item.shortname) !== -1;
      });
      //Trie les conseillers par nom de concession puis par prénom
      conseilors = conseilors.sort((a, b) => {
        if (a.shortname > b.shortname) return 1;
        if (a.shortname < b.shortname) return -1;

        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
      });
      this.setState({
        conseilors: json != null ? conseilors : [],
      });
      this.conseilors = conseilors;
    });
  }

  // Initialise la proposition pour une nouvelle création
  clearProposal() {
    this.setState({
      proposal: {discount: 0},
    });
  }

  // Edition des champs d'une nouvelle proposition
  handleRedux(event) {
    let proposal = this.state.proposal;
    proposal[event.target.name] = event.target.value;
    if (event.target.name === 'shortname') {
      proposal['conseilor'] = '';
    }

    this.setState({
      proposal: proposal,
    });
  }

  // Ajout d'une nouvelle proposition
  submit() {
    if (Object.getOwnPropertyNames(this.state.proposal).length <= 0) {
      ErrorManager.Instance.Error('Vous devez remplir le formulaire avant de pouvoir enregistrer.');
      return;
    }

    if (!Core.Instance.CheckForm(this)) {
      ErrorManager.Instance.Error('Un type de proposition est requis');
      return;
    }
    let proposal = this.state.proposal;
    let request = null;

    if (proposal.id) {
      request = Core.Instance.Request(Core.Address + 'UpdateProposal/', proposal, 'PUT');
    } else {
      request = Core.Instance.Request(Core.Address + 'SaveProposal', proposal, 'POST');
    }

    request
      .then((json) => {
        if (json === null) {
          alert('Le modèle ne correspond à aucun Flash');
        } else {
          ErrorManager.Instance.Info('Les informations ont bien été enregistrées.');
        }
        window.location.href = '/proposal';
      })
      .catch((error) => {
        ErrorManager.Instance.Handle(error);
      });
  }

  render() {
    const { dealerships, conseilors, models, proposals, allColumnsToggled, user_dealerships, sold, startDate, endDate } = this.state;
    let columns = null;
    let filteredRows = null;

    //Attends d'abord le chargement des données avant de créer les colonnes
    //Sinon bug des filtres
    if (dealerships.length > 0 && conseilors.length > 0 && models.length > 0 && proposals.length > 0) {
      if (allColumnsToggled) {
        columns = AllColumns(this.handleCheckbox, conseilors, dealerships, models);
      } else {
        columns = MainColumns(this.handleCheckbox, conseilors, dealerships, models);
      }

      filteredRows = getRows(proposals, this.state.filters);
    }

    let gridHeight = window.innerWidth > 1440 ? 720 : 640;
    return (
      <ErrorBoundary>
        <Header />
        <div className={`container-fluid ${columns && columns.length > 14 ? 'AllProposals' : 'MainProposals'}`}>
          <div className='row'>
            <div className='col'>
              <div className='card m-3 p-3'>
                <div className='card-body'>
                  <div className='card-title'>
                    <span className='h4 align-middle'>
                      Les offres <span className='badge badge-pill bg-green text-white'>{filteredRows ? filteredRows.length : 0}</span>
                    </span>
                    <BtnGroup
                      handleFilterChange={this.handleFilterChange}
                      sold={sold}
                      startDate={startDate}
                      endDate={endDate}
                      allColumnsToggled={allColumnsToggled}
                      onToggle={this.onToggle}
                      clearProposal={this.clearProposal}
                      user_dealerships={user_dealerships}
                    />
                  </div>
                  <div className='mt-3'>
                    {dealerships.length > 0 && conseilors.length > 0 && models.length > 0 && proposals.length > 0 && (
                      <ReactDataGrid
                        ref={this.grid}
                        className=''
                        columns={columns}
                        rowGetter={(i) => filteredRows[i]}
                        rowsCount={filteredRows.length + 1}
                        onGridRowsUpdated={this.onGridRowsUpdated}
                        onGridSort={(sortColumn, sortDirection) => {
                          this.setState({
                            proposals: sortRows(this.state.proposals, sortColumn, sortDirection),
                          });
                        }}
                        onAddFilter={(filter) => this.setState({ filters: handleFilterChange(filter, this.state.filters) })}
                        onClearFilters={() => this.setState({ filters: {} })}
                        getValidFilterValues={(columnKey) => getValidFilterValues(this.state.proposals, columnKey)}
                        enableCellSelect={true}
                        rowHeight={50}
                        minHeight={gridHeight}
                        getCellActions={(column, row) => getCellActions(column, row, this.loadProposal)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ProposalForm
            proposal={this.state.proposal}
            dealerships={this.state.dealerships}
            conseilors={this.state.conseilors}
            models={this.state.models}
            onChange={this.handleRedux}
            onSubmit={this.submit}
          />
        </div>
      </ErrorBoundary>
    );
  }
}

export default Proposal;



// WEBPACK FOOTER //
// ./src/Components/Views/Proposal/Proposal.js